import { render, staticRenderFns } from "./batchParent.vue?vue&type=template&id=578805c5&scoped=true&"
import script from "./batchParent.vue?vue&type=script&lang=js&"
export * from "./batchParent.vue?vue&type=script&lang=js&"
import style0 from "./batchParent.vue?vue&type=style&index=0&id=578805c5&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578805c5",
  null
  
)

export default component.exports